import { render, staticRenderFns } from "./ListSelectTests.vue?vue&type=template&id=2a21ca36&scoped=true&"
import script from "./ListSelectTests.vue?vue&type=script&lang=js&"
export * from "./ListSelectTests.vue?vue&type=script&lang=js&"
import style0 from "./ListSelectTests.vue?vue&type=style&index=0&id=2a21ca36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21ca36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
